var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(!_vm.value)?[_vm._v("\n      -\n    ")]:(_vm.isDaily)?[_c('span',[_vm._v("매일")])]:[_c('span',[_vm._v("매주 ")]),_c('span',{class:_vm.styles},[_vm._v(_vm._s(_vm.dayOfWeekText))])],_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }